import { useTranslate } from "src/i18n";

export const useTranslations = () => {
  const { t } = useTranslate();

  return {
    title: t("profilePage.apiKeys.title", "API ключи"),
    alert: t("alerts.dataFetchError", "Ошибка получения данных"),
  };
};
